export default "__VITE_ASSET__C0tsrmO0__"